module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M23.992 1.748V30.26c0 1.584-2 2.192-3.108 1.392L.98 17.468C-.128 16.66-.4 15.344.704 14.536L21.02.356c1.108-.808 2.972-.188 2.972 1.392z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-1.js
// module id = 1212
// module chunks = 14